(function () {
    "use strict";

    angular.module('app.productDetail', ['angular.filter']);
})();
